import { BaseManager } from '../core/baseManager';

export class CharacterCounterManager extends BaseManager {

    constructor() {
        super('CharacterCounterManager');
    }

    public initialize(): void {
        super.initialize();
        this.characterCounterHandler();
    }

    public characterCounterHandler(): void {
        const counters = document.querySelectorAll<HTMLDivElement>('.character-counter');

        counters.forEach(e => {
            let counterDisplay = e.querySelector("[data-character-count]");

            let textArea = e.parentElement?.querySelector<HTMLTextAreaElement>('textarea');

            if (textArea && counterDisplay) {
                textArea.addEventListener('input', (e) => {
                    counterDisplay!.textContent = (textArea!.value.length).toString();
                });
            }
        });
    }
}
